/**
 * GSAP Initialization Module
 * 
 * Initializes GSAP and Lenis smooth scrolling, makes them globally available
 * for use in both the parent theme (Regatta) and child theme (Midtown)
 */

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import Lenis from 'lenis';

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

// Initialize Lenis smooth scrolling
const lenis = new Lenis({
	duration: 1.2,
	easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
	touchMultiplier: 1.5,
});

// Connect Lenis to GSAP's ticker for perfectly synced animations
gsap.ticker.add((time) => {
	lenis.raf(time * 1000);
});
gsap.ticker.lagSmoothing(0);

// Keep ScrollTrigger in sync with Lenis
lenis.on('scroll', ScrollTrigger.update);

// Make GSAP and Lenis globally available on the window object
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.lenis = lenis;

// Export for ES6 module imports
export { gsap, ScrollTrigger, ScrollToPlugin, lenis };
export default gsap;
